/**
 * @p5doc module
 * @name handler/bonz-form
 *
 * @description
 * # MODULE_TITLE
 *
 * MODULE_DESCRIPTION.
 */
import {trackEvent} from "../tracking/gtm";


export default class BonzFormHandler {
  constructor($form) {
    this.$form = $form;
  }

  done({message}) {
    this.$form.find(".js-bonzHideOnDone").remove();
    this.$form.find(".js-bonzMessage").html(message);

    trackEvent("stolen_form_sent");
  }

  fail({responseJSON}) {
    for (let key in responseJSON) {
      if (responseJSON.hasOwnProperty(key)) {
        let messages = responseJSON[key];

        if (messages.length) {
          let $input = $(`#bonzForm-${key}`);

          $input
            .addClass("is-erroneous mb-1");

          messages.forEach(function (msg) {
            $input.after(renderErrorMsg({msg}));
          });
        }
      }
    }
  }

  always() {
    this.cleanup();
  }

  cleanup() {
    this.$form.find(".is-erroneous").removeClass("is-erroneous"); // Restore styles.
    this.$form.find(".FormControl-errorMsg").remove(); // Remove old messages.
  }
}

function renderErrorMsg({msg}) {
  return `
<p class="FormControl-errorMsg">
  ${msg}
</p>`;
}
